import { Injectable } from '@angular/core';
import { GlobalConstants } from '../constant/constant';
import { StoreName } from '../entities/StoreName';
import ChoiceDefinition from '../models/choice-definition/choice-definition';
import { ChoiceDefinitionMetadata } from '../models/choice-definition/choice-definition-metadata';
import { DbTransaction } from '../models/db/db-transaction';
import { DataService } from './data.service';
import { RecordNotFoundException } from '../utils/exceptions';

@Injectable({
  providedIn: 'root',
})
export class ChoiceDefinitionsService extends DataService {
  constructor() {
    super();
  }

  private async startTransactionIfNeeded(existingTransaction?: DbTransaction): Promise<DbTransaction> {
    return existingTransaction || (await this.repository.startTransaction([StoreName.ChoiceDefinition, StoreName.FormDefinition], 'readwrite'));
  }

  async getAllMetadata(filter?: any, existingTransaction?: DbTransaction): Promise<ChoiceDefinitionMetadata[]> {
    return await this.repository.getAllPartialFields(StoreName.ChoiceDefinition, ChoiceDefinitionMetadata, filter, undefined, existingTransaction);
  }

  async getOneMetadata(choiceDefinitionId: number, existingTransaction?: DbTransaction): Promise<ChoiceDefinitionMetadata> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const result = await this.repository.getOnePartialFieldsByIndex<ChoiceDefinitionMetadata, ChoiceDefinitionMetadata>(StoreName.ChoiceDefinition, GlobalConstants.KEY_NAMES.Id, choiceDefinitionId, ChoiceDefinitionMetadata, undefined, transaction);

    if (result === null) {
      throw new RecordNotFoundException(choiceDefinitionId);
    }

    return result;
  }

  async getOne(choiceDefinitionId: number, existingTransaction?: DbTransaction): Promise<ChoiceDefinition> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    return await this.repository.getOneByIndex(StoreName.ChoiceDefinition, GlobalConstants.KEY_NAMES.Id, choiceDefinitionId, undefined, transaction);
  }

  async insertOne(choiceDefinition: ChoiceDefinition, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const existingChoiceDefinition = await this.getOne(choiceDefinition.id, transaction);
    if (existingChoiceDefinition) {
      choiceDefinition.RecordId = existingChoiceDefinition.RecordId;
    }

    await this.repository.create(choiceDefinition, StoreName.ChoiceDefinition, transaction);
  }

  async insertMany(choiceDefinitions: ChoiceDefinition[], existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    for (const choiceDefinition of choiceDefinitions) {
      await this.insertOne(choiceDefinition, transaction);
    }
  }

  /**
   *  @todo Refactor to delete by Id and implement transaction pattern
   */
  async deleteMany(choiceDefinitions: ChoiceDefinitionMetadata[] | ChoiceDefinition[]) {
    await this.repository.deleteBulkData(choiceDefinitions, StoreName.ChoiceDefinition);
  }
}
